module.exports = __webpack_public_path__ + "static/media/union_white.18c31b4e.png";